import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import App from "./App";
import ErrorCatchPage from "./_ErrorCatchPage";

const queryClient = new QueryClient();


ReactDOM.render(
  <React.StrictMode>
    <ErrorCatchPage>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <App />
          <ReactQueryDevtools />
        </QueryClientProvider>
      </BrowserRouter>
    </ErrorCatchPage>
  </React.StrictMode>,
  document.getElementById("root")
);
